module.exports = __webpack_public_path__ + "img/icon3.a356f2e2.svg";